import React from "react";
import("./styles/index.css");
import("./assets/css/syncfusion-bootstrap5.3.css");
import("bootstrap/dist/css/bootstrap.min.css");

import ReactDOM from "react-dom/client";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faChevronLeft,
    faSignOutAlt,
    faSave,
    faCircleUser,
    faFileInvoice,
    faFilePdf,
    faInfoCircle,
    faUsersBetweenLines,
    faUsersRays,
    faTractor,
    faBars,
    faTableColumns,
    faNewspaper,
    faGear,
    faUserGear,
    faSliders,
    faBook,
    faUserSecret,
    faChartLine,
    faChartSimple,
    faMagnifyingGlass,
    faArrowRotateRight,
    faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";

import { Provider } from "react-redux";
import { store } from "./store";
import { registerLicense } from "@syncfusion/ej2-base";
import { Suspense } from "react";
import AuthProvider from "@ibcos/ui-components/dist/components/Hooks/useAuth/AuthProvider";
import LoadingSpinner from "./components/LoadingSpinner";
import AppRouter from "./router/AppRouter";
import GoldErrorBoundaryWrapper from "./components/FallbackUI/GoldErrorBoundaryWrapper";
import { resizeListener } from "./utilities/ResizeUtility";

library.add(
    faChevronLeft,
    faSignOutAlt,
    faSave,
    faTractor,
    faCircleUser,
    faFileInvoice,
    faBook,
    faFilePdf,
    faInfoCircle,
    faUsersBetweenLines,
    faUsersRays,
    faBars,
    faTableColumns,
    faNewspaper,
    faSliders,
    faGear,
    faUserGear,
    faUserSecret,
    faChartLine,
    faChartSimple,
    faMagnifyingGlass,
    faArrowRotateRight,
    faArrowUpRightFromSquare
);

registerLicense(import.meta.env.VITE_DCP_SYNCFUSION_LICENSE_KEY);
resizeListener();

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <GoldErrorBoundaryWrapper>
            <AuthProvider bffRootUrl={`${import.meta.env.VITE_BFF_PROXY}/bff`}>
                <Provider store={store}>
                    <Suspense fallback={<LoadingSpinner />}>
                        <AppRouter />
                    </Suspense>
                </Provider>
            </AuthProvider>
        </GoldErrorBoundaryWrapper>
    </React.StrictMode>
);
